import { Divider, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";

export default function({heading}) {
    return <Box>
        <Typography variant="h6" gutterBottom>{heading}</Typography>
        <Divider/>
    </Box>
}